import {commitMutation, graphql} from 'react-relay';
import type {Environment, Disposable} from 'relay-runtime';
import {csrfToken, socketClientId} from '../../../forecast-app/ticketing/graphql/forecastRelay';
import type {markAllTicketNotificationsReadMutation} from './__generated__/markAllTicketNotificationsReadMutation.graphql';

const mutation = graphql`
	mutation markAllTicketNotificationsReadMutation($input: MarkAllTicketNotificationsReadInput!) {
		markAllTicketNotificationsRead(input: $input) {
			marked
		}
	}
`;

function commit(
	environment: Environment,
	_input: unknown,
	onCompleted?: (r: markAllTicketNotificationsReadMutation['response']) => void,
	onError?: (e: Error) => void
): Disposable {
	return commitMutation<markAllTicketNotificationsReadMutation>(environment, {
		mutation,
		variables: {input: {csrfToken: csrfToken(), socketClientId: socketClientId()}},
		onCompleted: onCompleted ? response => onCompleted(response) : undefined,
		onError: onError ? error => onError(error) : undefined,
	});
}

export default {commit, mutationId: 'markAllTicketNotificationsReadMutation'};
